module.exports = __webpack_public_path__ + "static/s107_large-57745dde01d921cb115e404e742a1de3.jpg";